/* This component CREATES one entry for the historys collection in MongoDB.
   As the entry is being CREATED, it should then activate the HistoryRead component
   to show the entry as it is being built. */

import React, { useEffect, useState }           from 'react'
import axios                                    from 'axios'
import Box                                      from "@material-ui/core/Box"
import {
   Link,
   Grid,
   Typography }                                 from '@material-ui/core'
import { CLIENT_PUBLIC_TOKEN }                  from '../config'
import PropTypes                                from 'prop-types'
import { node_server }                          from '../Helpers'

const HistoryCitationReadComponent = ( { data, handleClick, page }) => {

   const [ citations,                           setCitations   ]  =  useState([])

   useEffect( () => {
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.get(node_server + 'historyCitation')
      .then( res => res.data )
      .then( data => {
         let text
         setCitations(data.entry.map( c => {
            if ( c.link === '' || page === 'history_citation_update' ) {
               text = 
                  <Typography key={c._id} align='left' onClick={() => handleClick(c._id)} style={{cursor: 'pointer'}} >
                     [ { c.citation_number } ] {c.citation}
                  </Typography>  

            }
            else {
               text =
                  <Link key={c._id} href={c.link} target="_blank" rel="noopener noreferrer" >
                     <Typography key={c._id} align='left' >
                        [ { c.citation_number } ] {c.citation}
                     </Typography>
                  </Link>
            }
            return( text )
         }))
      })
      .catch( (error) => {
         console.error(error)
      })

   }, [data])

   return (
      <Box >
         <Grid style={{ padding: '2rem' }} >
            { citations }
         </Grid>
      </Box>
   )
}

HistoryCitationReadComponent.propTypes = {
   data:                                        PropTypes.array,
   handleClick:                                 PropTypes.func,
   page:                                        PropTypes.string
}

export default HistoryCitationReadComponent
